const dropZoneDialogStyle = ({ spacing }) => ({});

export default dropZoneDialogStyle;
